"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInstallmentsCrossStep = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _tabs = require("@creditas-lab/tabs");

var _constants = require("../../constants");

var _ModalBody = require("../ModalBody");

var _EditCreditSection = require("../EditCreditSection");

var _ProductInstallments = require("./ProductInstallments/ProductInstallments");

var _ProductInstallmentsStep = require("./ProductInstallmentsStep.style");

var _useProductInstallmentsStep = require("./useProductInstallmentsStep");

var _useProductInstallmentsCrossStep = require("./useProductInstallmentsCrossStep");

var _core = require("@emotion/core");

var ProductInstallmentsCrossStep = function ProductInstallmentsCrossStep() {
  var _ref = (0, _useProductInstallmentsCrossStep.useProductInstallmentsCrossStep)(),
      tabs = _ref.tabs,
      onTabChange = _ref.onTabChange;

  var _ref2 = (0, _useProductInstallmentsStep.useProductInstallmentsStep)(),
      intendedCredit = _ref2.intendedCredit,
      closeSimulator = _ref2.closeSimulator,
      _onRequestProposalClick = _ref2.onRequestProposalClick;

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_ProductInstallmentsStep.ModalHeader, {
    onClose: closeSimulator
  }, (0, _core.jsx)(_EditCreditSection.EditCreditSection, {
    value: intendedCredit
  })), (0, _core.jsx)(_ModalBody.ModalBody, {
    "data-testid": "product-installments-step-content"
  }, (0, _core.jsx)(_ProductInstallmentsStep.TabsContainer, null, (0, _core.jsx)(_tabs.Tabs, (0, _extends2.default)({
    onTabChange: onTabChange
  }, tabs), (0, _core.jsx)(_tabs.TabList, null, (0, _core.jsx)(_tabs.TabItem, null, "Im\xF3vel em garantia"), (0, _core.jsx)(_tabs.TabItem, null, "Carro em garantia")), (0, _core.jsx)(_tabs.TabsPanel, null, Object.values(_constants.ProductTypes).map(function (product) {
    return (0, _core.jsx)(_tabs.Tab, {
      key: "product-tab-".concat(product)
    }, (0, _core.jsx)(_ProductInstallments.ProductInstallments, {
      productType: product,
      "data-testid": "product-".concat(product),
      intendedCredit: intendedCredit,
      onRequestProposalClick: function onRequestProposalClick() {
        return _onRequestProposalClick(product);
      }
    }));
  }))))));
};

exports.ProductInstallmentsCrossStep = ProductInstallmentsCrossStep;
ProductInstallmentsCrossStep.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProductInstallmentsCrossStep"
};